import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getTopCriticalPathAdded';

export const getTopCriticalPathAdded = (params) => {
    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
